import { Get } from '../requestBuilder/buildFetchRequest';
import PagedResponse from '../PagedResponse';
import NonConformance from './NonConformance';
import NonConformanceQueryOptions from './NonConformanceQueryOptions';
import { QueryParameters, buildQueryParams } from '../QueryParameters';

export const getNonConformances = (query: QueryParameters<NonConformance, NonConformanceQueryOptions>): Promise<PagedResponse<NonConformance>> => (
  Get('/api/nonConformances')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getNonConformance = (nonConformanceId: number): Promise<NonConformance> => (
  Get(`/api/nonConformances/${nonConformanceId}`)
    .Execute()
);
